import { useState } from 'react';
import { PatientChatProvider, useChatApiVersion } from '@odo/shared-ui';
import { getChatService } from '../../../services/chatService';
import type { ChatType } from '../../../services/chat';
import { useChatStatus } from '../../../hooks/useChatStatus';
import { usePatientCard } from '../../../hooks/usePatientCard';
import ConversationActionsBar from '../../conversations/ConversationActionsBar';
import { ChatModeToggle } from '../../conversations/ChatModeToggle';
import { ChatTab } from '../../patient-files/ChatTab';

interface PatientConversationPanelProps {
    patientId: string;
}

// The patient files conversation, External/Internal toggle included, sized for a task sidebar.
export function PatientConversationPanel({ patientId }: PatientConversationPanelProps) {
    const [chatMode, setChatMode] = useState<ChatType>('external');
    const { version: chatApiVersion } = useChatApiVersion();
    const { data: card } = usePatientCard(patientId);
    const { isUnread: hasUnreadExternal } = useChatStatus(patientId, 'external');
    const { isUnread: hasUnreadInternal } = useChatStatus(patientId, 'internal');

    return (
        <div className="flex flex-col flex-1 min-h-0">
            <ChatModeToggle
                value={chatMode}
                onChange={setChatMode}
                internalDisabled={!card?.boards?.orthoItemId}
                hasUnreadExternal={hasUnreadExternal}
                hasUnreadInternal={hasUnreadInternal}
            />
            <PatientChatProvider
                key={`${chatMode}-${chatApiVersion}`}
                patientId={patientId}
                service={getChatService(chatApiVersion)}
                chatType={chatMode}
                includeActivities
            >
                <ConversationActionsBar patientId={patientId} chatType={chatMode} />
                <ChatTab />
            </PatientChatProvider>
        </div>
    );
}
